//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { directive } from 'vue-awesome-swiper'

export default {
  name: 'MathRoadmap',
  components: {},
  directives: {
    swiper: directive,
  },
  props: {
    trustScreenTitle: {
      type: String,
      required: true,
    },
    trustScreenItem1Title: {
      type: String,
      required: true,
    },
    trustScreenItem1Text: {
      type: String,
      required: true,
    },
    trustScreenItem2Title: {
      type: String,
      required: true,
    },
    trustScreenItem2Text: {
      type: String,
      required: true,
    },
    trustScreenItem3Title: {
      type: String,
      required: true,
    },
    trustScreenItem3Text: {
      type: String,
      required: true,
    },
    trustScreenItem4Title: {
      type: String,
      required: true,
    },
    trustScreenItem4Text: {
      type: String,
      required: true,
    },
    trustScreenItem5Title: {
      type: String,
      required: true,
    },
    trustScreenItem5Text: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      styleImage: '',
      swiperOptions: {
        pagination: {
          el: '.swiper-pagination',
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      isDesktop: null,
    }
  },
  mounted() {
    this.windowSizeHandler()
    window.addEventListener('resize', this.windowSizeHandler, { passive: true })
  },
  methods: {
    imageRoadmap(settingsKey, defaultCodingImg, defaultNoCodingImg) {
      const alternativeImg = this.$getBullets(settingsKey)
      if (alternativeImg[0]) {
        this.styleImage = 'width: 115%; height: 150%; border-radius: 100%;'
        return alternativeImg[0].url
      }

      return require(`@/assets/img/redesign/coding/${
        this.$route.path === '/coding' ? defaultCodingImg : defaultNoCodingImg
      }.png`)
    },
    imageRoadmapChilds(settingsKey) {
      const alternativeImg = this.$getBullets(settingsKey)
      if (alternativeImg[0]) {
        this.styleImage = 'width: 115%; height: 150%; border-radius: 100%;'
        return alternativeImg[0].url
      }

      return require('@/assets/img/redesign/coding/math_road_5.png')
    },
    imageRoadmapFirst() {
      if (this.$route.path === '/coding') {
        return require(`@/assets/img/redesign/coding/programming_road_1.png`)
      }

      const alternativeImg = this.$getBullets('trustScreenItemPicture1')
      if (alternativeImg[0]) {
        this.styleImage = 'width: 115%; height: 150%; border-radius: 100%;'
        return alternativeImg[0].url
      }

      return require(`@/assets/img/redesign/coding/math_road_3.png`)
    },
    windowSizeHandler() {
      this.isDesktop = window.innerWidth <= 1280
    },
  },
}
